<template>
    <label class="mb-0" style="cursor:pointer;">
        <input type="checkbox" :checked="checked" :disabled="saving" @change="toggle($event)" />
    </label>
</template>

<script>
import { axiosPost } from "../../../../common/Helper/AxiosHelper";
import { PRODUCT_FLAG_TOGGLE } from "../../../Config/ApiUrl-CP";

export default {
    name: 'app-product-flag-toggle',
    // 'extraval' carries which flag this cell controls: 'inventory' or 'available'
    props: ['rowData', 'value', 'extraval', 'tableId', 'index', 'data'],
    data() {
        return {
            checked: false,
            saving: false,
        };
    },
    computed: {
        field() {
            return this.extraval;
        },
        product() {
            return this.rowData && this.rowData.product ? this.rowData.product : null;
        },
    },
    created() {
        this.checked = this.product ? Number(this.product[this.field]) === 1 : false;
    },
    methods: {
        toggle(event) {
            if (!this.product) return;
            const val = event.target.checked ? 1 : 0;
            const previous = this.checked;
            this.saving = true;

            const data = new FormData();
            data.append('product_id', this.product.id);
            data.append('field', this.field);
            data.append('value', val);

            axiosPost(PRODUCT_FLAG_TOGGLE, data).then(() => {
                this.checked = !!val;
                this.product[this.field] = val; // keep row in sync
                this.$toastr.s(`${this.field === 'inventory' ? 'Inventory' : 'Available'} updated.`);
            }).catch(() => {
                event.target.checked = previous; // revert
                this.$toastr.e('Could not update the flag.');
            }).finally(() => {
                this.saving = false;
            });
        },
    },
};
</script>
